const SILO_ACCESSOR = Symbol.for('silo_v1');
/* This file is compiled with simple-cjs-loader before being inlined into apps' HTML.
 * In that context, we're restricted from:
 * - Importing anything other than types
 * - Exporting anything other than types and function declarations
 *
 * Exports that do not follow this rule are eliminated by the loader, but so long as we don't
 * **export** it, variables can still be defined and used (e.g SILO_ACCESSOR).
 *
 * Some of the functions in this file are imported elsewhere and called at runtime
 * to ensure behavior is kept in sync between the two contexts.
 *
 * Everything below this point **must** use only function declarations and non-exported values
 * **from this file**.
 */

export function makeScopedState(...initialValues) {
  return {
    values: new Map(initialValues),
    watchers: new Map()
  };
}
export function getBuildTimePropertyNames() {
  return {
    copilotLayoutType: 'copilot_layout_type',
    currentPackageName: 'current_package_name',
    currentPackageVersion: 'current_package_version',
    rootPackageName: 'root_package_name',
    rootPackageVersion: 'root_package_version'
  };
}
export function getGlobalState(win = window) {
  return win[SILO_ACCESSOR];
}

// Parameters are injected at build time
export function initialize(appName, appVersion, copilotLayoutType) {
  var _nearestAncestor$SILO;
  if (getGlobalState()) {
    throw Error('Global state already initialized');
  }
  let nearestAncestor = window;
  while (nearestAncestor.parent !== nearestAncestor) {
    try {
      // Will throw when the parent window is from a different domain
      const __sameOriginTest = nearestAncestor.parent.document;
      nearestAncestor = nearestAncestor.parent;
      if (getGlobalState(nearestAncestor.parent)) {
        break;
      }
    } catch (e) {
      // Skip different origin frame
      break;
    }
  }
  const {
    copilotLayoutType: copilotLayoutTypePropertyName,
    currentPackageName,
    currentPackageVersion,
    rootPackageName,
    rootPackageVersion
  } = getBuildTimePropertyNames();
  window[SILO_ACCESSOR] = {
    TAB: ((_nearestAncestor$SILO = nearestAncestor[SILO_ACCESSOR]) === null || _nearestAncestor$SILO === void 0 ? void 0 : _nearestAncestor$SILO.TAB) || makeScopedState([rootPackageName, appName], [rootPackageVersion, appVersion]),
    BROWSING_CONTEXT: makeScopedState([currentPackageName, appName], [currentPackageVersion, appVersion], [copilotLayoutTypePropertyName, copilotLayoutType])
  };
}